import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { CreatedFileStorage, FileInformation } from '../../core';
import { Result } from '@digibricks/domains';
export var FileStorageMapper = /*#__PURE__*/function () {
  function FileStorageMapper() {
    _classCallCheck(this, FileStorageMapper);
  }

  _createClass(FileStorageMapper, [{
    key: "toDomain",
    value: function toDomain(input) {
      var fileInformation = input.fileInformation,
          url = input.url,
          uploadUrl = input.uploadUrl,
          id = input.id;
      var fileInformationResponseOrError = FileInformation.create(fileInformation);

      if (fileInformationResponseOrError.isFailure) {
        return Result.fail(fileInformationResponseOrError.error);
      }

      var createFileStorageResponseOrError = CreatedFileStorage.create({
        url: url,
        uploadUrl: uploadUrl,
        fileInformation: fileInformationResponseOrError.getValue()
      }, id);

      if (createFileStorageResponseOrError.isFailure) {
        return Result.fail(createFileStorageResponseOrError.error);
      }

      return createFileStorageResponseOrError;
    }
  }]);

  return FileStorageMapper;
}();